module.exports = __webpack_public_path__ + "img/kitsune_image.bafc5300.jpg";